<template>
  <div style="padding:10px 20px 10px 10px;">
    <CloseButton type="close" msg="closeWindow"></CloseButton>
    <router-view></router-view>
  </div>
</template>
<script>
// 用于自定义菜单节点
export default {
    name: `AnesLayout`,
    props: {

    },
    data() {
        return {
            title: `麻醉弹出框样式`
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/Layout.vue